import { render, staticRenderFns } from "./myInsurance.vue?vue&type=template&id=89e8427e&scoped=true&"
import script from "./myInsurance.vue?vue&type=script&lang=js&"
export * from "./myInsurance.vue?vue&type=script&lang=js&"
import style0 from "./myInsurance.vue?vue&type=style&index=0&lang=less&"
import style1 from "./myInsurance.vue?vue&type=style&index=1&id=89e8427e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e8427e",
  null
  
)

export default component.exports